jQuery(document).ready(function ($) {
    initFixedHeader(); 
    initProductTabs();
    //initCollectionListToggle();
    initSearchToggler();
  
    function initFixedHeader() {
        if ($(window).scrollTop() > $('#main > *:visible').eq(0).offset().top-68-$('.header-promo').height() ) {
            $('#header').addClass('fixed');
        }
        $(window).scroll(function () {
            if ($(this).scrollTop() > $('#main > *:visible').eq(0).offset().top-68-$('.header-promo').height()) {
                $('#header').addClass('fixed');
            } else {
                $('#header').removeClass('fixed');
            }
        });
    }

    function initProductTabs() {
      $('[data-tabs] .tabs-nav a').click(function(e) {
        e.preventDefault();
        var $link = $(this);
        var id    = $link.attr('href');
        var $tab  = $('[data-tabs] .tab'+id);
        if($tab.length > 0) {
          $.when( $('[data-tabs] .tabs-nav a.active, [data-tabs] .tab.active').removeClass('active') ).then(
            $link.addClass('active'), $tab.addClass('active')
          );
        }
      });
    }
  
    function initCollectionListToggle() {
      $('.collections-menu-toggler').click(function(e) {
        e.preventDefault();
        $(this).next().slideToggle();
      });
    }

    function initSearchToggler() {
      $('#collection-search-toggle').click(function(e) {
        e.preventDefault();
        $('#collection-search-form').slideToggle();
      });      
    }
});